import { render } from "./MobilePaymentProviders.vue?vue&type=template&id=1a1e8541"
import script from "./MobilePaymentProviders.vue?vue&type=script&lang=js"
export * from "./MobilePaymentProviders.vue?vue&type=script&lang=js"

import "./MobilePaymentProviders.vue?vue&type=style&index=0&id=1a1e8541&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__